window.$ = window.jQuery = require('jquery');
require('./bootstrap');
require('@popperjs/core');
require('bootstrap-autocomplete');
require("@fancyapps/ui");
require("bootstrap-autocomplete");
window.slick = require("slick-carousel");
